import React from 'react'

const OxygenPaymentConfirmationSucess = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 p-5 md:p-2">
      {/* Check Icon */}
      <div className="mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          fill="green"
          className="bi bi-check-circle"
          viewBox="0 0 16 16"
        >
          <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
          <path d="M10.97 5.97a.75.75 0 0 0-1.07-1.05L7.477 8.417 6.324 7.262a.75.75 0 1 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.079-.02l3.5-4.5z" />
        </svg>
      </div>

      {/* Text */}
      <h4 className="fw-bold mt-4 fs-2">Congratulations!</h4>
      <p className="text-center mb-4 fs-6 md:fs-5">
        Your payment has been successfully processed, you can now go back to complete your onboarding process.
      </p>
    
    </div>
  )
}

export default OxygenPaymentConfirmationSucess;